import { render, staticRenderFns } from "./darwer-plot.vue?vue&type=template&id=4fafde77&scoped=true&"
import script from "./darwer-plot.vue?vue&type=script&lang=ts&"
export * from "./darwer-plot.vue?vue&type=script&lang=ts&"
import style0 from "./darwer-plot.vue?vue&type=style&index=0&id=4fafde77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fafde77",
  null
  
)

export default component.exports